import Stats from "../../components/cards";
import styles from "./dashboard.module.css";
import { useCallback, useState, useContext, useEffect } from "react";
import { UserContext } from "../../context/userContext";
import { apiConfig } from "../../commonFunction/apiconfig";
import axios from "axios";

export default function Dashboard() {
  const { userToken } = useContext(UserContext);
  const [data, setData] = useState({
    reward: [],
    assets: [],
    plans: [],
    wallets: [],
  });
  const [parameter, setParameter] = useState({
    fromDate: "",
    toDate: "",
  });

  const getDashboardCounts = useCallback(async () => {
    if (userToken === "") return;
    try {
      const headers = {
        token: userToken,
      };
      const res = await axios.get(
        `${apiConfig.dashboardCount}?fromDate=${parameter?.fromDate}&toDate=${parameter?.toDate}`,
        { headers }
      );
      if (res.data.statusCode === 200) {
        const rewardData = res.data.result.reward;
        const assetsData = res.data.result.asset;
        const plansData = res.data.result.plans;
        const walletsData = res.data.result.wallets[0];

        setData((prevState) => ({
          ...prevState,
          reward: rewardData,
          assets: assetsData,
          plans: plansData,
          wallets: walletsData,
        }));
      } else {
        setData({
          reward: [],
          assets: [],
          plans: [],
          wallets: [],
        });
      }
    } catch (error) {
      console.log(error);
      setData([]);
    }
  }, [parameter, userToken]);

  useEffect(() => {
    getDashboardCounts();
  }, [getDashboardCounts]);

  const parseCurrency = (currencyString) => {
    if (currencyString) {
      // Remove the '$' and ',' from the formatted currency string, then parse it as a number
      //return parseFloat(currencyString.replace(/[^\d.-]/g, ""));
      currencyString = currencyString.toString();
      const parsedValue = parseFloat(
        currencyString.replace(/[^0-9.-]+/g, "")
      );
      return isNaN(parsedValue) ? 0 : parsedValue;
    }
    return 0;
  };

  const getDashboardMappedData = (type, rawData, id = "") => {
    if (!rawData || !type) return [];
    console.log(rawData);
    const formatCurrency = (amount) =>
      amount?.toLocaleString("en-US", { style: "currency", currency: "USD" });

    switch (type) {
      case "reward":
        const rewardItem = rawData?.find((item) => item._id === id);
        return rewardItem ? formatCurrency(rewardItem.amount?.toFixed(2)) : "0";

      case "asset":
        const assetItem = rawData?.find((item) => item._id === id);
        return assetItem ? formatCurrency(assetItem.amount?.toFixed(2)) : "0";

      case "plansAmount":
        const plansItem = rawData?.find((item) => item.name === id);
        const activePlanAmount = plansItem
          ? formatCurrency(plansItem.activePlanAmount?.toFixed(2))
          : "0";
        return activePlanAmount;

      case "plansPayable":
        const plansPayableItem = rawData?.find((item) => item.name === id);
        const totalPaybleAmount = plansPayableItem
          ? formatCurrency(plansPayableItem.totalPaybleAmount?.toFixed(2))
          : "0";
        return totalPaybleAmount;

      default:
        return 0;
    }
  };

  console.log(data.wallets, "data");

  const rewardData = [
    {
      title: "ROI Daily",
      value: getDashboardMappedData("reward", data?.reward, "ROI_DAILY"),
      icon: "/icons/users.svg",
    },
    {
      title: "ROI Monthly",
      value: getDashboardMappedData("reward", data?.reward, "ROI_MONTHLY"),
      icon: "/icons/revenue.svg",
    },
    {
      title: "Team Dividend",
      value: getDashboardMappedData("reward", data?.reward, "TEAM_ROI"),
      icon: "/icons/growth.svg",
    },
    {
      title: "Direct Referral",
      value: getDashboardMappedData("reward", data?.reward, "Referral"),
      icon: "/icons/feedback.svg",
    },
  ];
  const transactionData = [
    {
      title: "Deposit",
      value: getDashboardMappedData("asset", data?.assets, "DEPOSIT"),
      icon: "/icons/users.svg",
    },
    {
      title: "Withdraw",
      value: getDashboardMappedData("asset", data?.assets, "WITHDRAW"),
      icon: "/icons/revenue.svg",
    },
    {
      title: "Transfer",
      value: getDashboardMappedData("asset", data?.assets, "TRANSFER"),
      icon: "/icons/growth.svg",
    },
    {
      title: "Credit",
      value: getDashboardMappedData("asset", data?.assets, "CREDIT"),
      icon: "/icons/feedback.svg",
    },
    {
      title: "Debit",
      value: getDashboardMappedData("asset", data?.assets, "DEBIT"),
      icon: "/icons/feedback.svg",
    },
    {
      title: "Plan Purchase",
      value: getDashboardMappedData("asset", data?.assets, "PLAN PURCHASE"),
      icon: "/icons/feedback.svg",
    },
  ];

  const TotalInvestmentAmountUser =
    parseCurrency(
      getDashboardMappedData("plansAmount", data?.plans, "Express Gold USER")
    ) +
    parseCurrency(
      getDashboardMappedData("plansAmount", data?.plans, "Express Diamond USER")
    ) +
    parseCurrency(
      getDashboardMappedData("plansAmount", data?.plans, "Express Pro USER")
    ) +
    parseCurrency(
      getDashboardMappedData("plansAmount", data?.plans, "Stake & Earn 18 USER")
    ) +
    parseCurrency(
      getDashboardMappedData("plansAmount", data?.plans, "Stake & Earn 16 USER")
    );

  const TotalInvestmentPayableUser =
    parseCurrency(
      getDashboardMappedData("plansPayable", data?.plans, "Express Gold USER")
    ) +
    parseCurrency(
      getDashboardMappedData(
        "plansPayable",
        data?.plans,
        "Express Diamond USER"
      )
    ) +
    parseCurrency(
      getDashboardMappedData("plansPayable", data?.plans, "Express Pro USER")
    ) +
    parseCurrency(
      getDashboardMappedData(
        "plansPayable",
        data?.plans,
        "Stake & Earn 18 USER"
      )
    ) +
    parseCurrency(
      getDashboardMappedData(
        "plansPayable",
        data?.plans,
        "Stake & Earn 16 USER"
      )
    );

  const TotalInvestmentAmountAdmin =
    parseCurrency(
      getDashboardMappedData("plansAmount", data?.plans, "Express Gold ADMIN")
    ) +
    parseCurrency(
      getDashboardMappedData(
        "plansAmount",
        data?.plans,
        "Express Diamond ADMIN"
      )
    ) +
    parseCurrency(
      getDashboardMappedData("plansAmount", data?.plans, "Express Pro ADMIN")
    ) +
    parseCurrency(
      getDashboardMappedData(
        "plansAmount",
        data?.plans,
        "Stake & Earn 16 ADMIN"
      )
    ) +
    parseCurrency(
      getDashboardMappedData(
        "plansAmount",
        data?.plans,
        "Stake & Earn 18 ADMIN"
      )
    );

  const TotalInvestmentPayableAdmin =
    parseCurrency(
      getDashboardMappedData("plansPayable", data?.plans, "Express Gold ADMIN")
    ) +
    parseCurrency(
      getDashboardMappedData(
        "plansPayable",
        data?.plans,
        "Express Diamond ADMIN"
      )
    ) +
    parseCurrency(
      getDashboardMappedData("plansPayable", data?.plans, "Express Pro ADMIN")
    ) +
    parseCurrency(
      getDashboardMappedData(
        "plansPayable",
        data?.plans,
        "Stake & Earn 18 ADMIN"
      )
    ) +
    parseCurrency(
      getDashboardMappedData(
        "plansPayable",
        data?.plans,
        "Stake & Earn 16 ADMIN"
      )
    );

  const investmentData = [
    {
      title1: "Express Gold (User)",
      value1: getDashboardMappedData(
        "plansAmount",
        data?.plans,
        "Express Gold USER"
      ),
      title2: "Payable Amount",
      value2: getDashboardMappedData(
        "plansPayable",
        data?.plans,
        "Express Gold USER"
      ),
    },
    {
      title1: "Express Diamond (User)",
      value1: getDashboardMappedData(
        "plansAmount",
        data?.plans,
        "Express Diamond USER"
      ),
      title2: "Payable Amount",
      value2: getDashboardMappedData(
        "plansPayable",
        data?.plans,
        "Express Diamond USER"
      ),
    },
    {
      title1: "Express Pro (User)",
      value1: getDashboardMappedData(
        "plansAmount",
        data?.plans,
        "Express Pro USER"
      ),
      title2: "Payable Amount",
      value2: getDashboardMappedData(
        "plansPayable",
        data?.plans,
        "Express Pro USER"
      ),
    },
    {
      title1: "Stake & Earn 16 (User)",
      value1: getDashboardMappedData(
        "plansAmount",
        data?.plans,
        "Stake & Earn 16 USER"
      ),
      title2: "Payable Amount",
      value2: getDashboardMappedData(
        "plansPayable",
        data?.plans,
        "Stake & Earn 16 USER"
      ),
    },
    {
      title1: "Stake & Earn 18 (User)",
      value1: getDashboardMappedData(
        "plansAmount",
        data?.plans,
        "Stake & Earn 18 USER"
      ),
      title2: "Payable Amount",
      value2: getDashboardMappedData(
        "plansPayable",
        data?.plans,
        "Stake & Earn 18 USER"
      ),
    },
    {
      title1: "Total (User)",
      value1: `$${TotalInvestmentAmountUser?.toFixed(2)}`,
      title2: "Payable Amount",
      value2: `$${TotalInvestmentPayableUser?.toFixed(2)}`,
    },
    {
      title1: "Express Gold (Admin)",
      value1: getDashboardMappedData(
        "plansAmount",
        data?.plans,
        "Express Gold ADMIN"
      ),
      title2: "Payable Amount",
      value2: getDashboardMappedData(
        "plansPayable",
        data?.plans,
        "Express Gold ADMIN"
      ),
    },
    {
      title1: "Express Diamond (Admin)",
      value1: getDashboardMappedData(
        "plansAmount",
        data?.plans,
        "Express Diamond ADMIN"
      ),
      title2: "Payable Amount",
      value2: getDashboardMappedData(
        "plansPayable",
        data?.plans,
        "Express Diamond ADMIN"
      ),
    },
    {
      title1: "Express Pro (Admin)",
      value1: getDashboardMappedData(
        "plansAmount",
        data?.plans,
        "Express Pro ADMIN"
      ),
      title2: "Payable Amount",
      value2: getDashboardMappedData(
        "plansPayable",
        data?.plans,
        "Express Pro ADMIN"
      ),
    },
    {
      title1: "Stake & Earn 16 (ADMIN)",
      value1: getDashboardMappedData(
        "plansAmount",
        data?.plans,
        "Stake & Earn 16 ADMIN"
      ),
      title2: "Payable Amount",
      value2: getDashboardMappedData(
        "plansPayable",
        data?.plans,
        "Stake & Earn 16 ADMIN"
      ),
    },
    {
      title1: "Stake & Earn 18 (ADMIN)",
      value1: getDashboardMappedData(
        "plansAmount",
        data?.plans,
        "Stake & Earn 18 ADMIN"
      ),
      title2: "Payable Amount",
      value2: getDashboardMappedData(
        "plansPayable",
        data?.plans,
        "Stake & Earn 18 ADMIN"
      ),
    },
    {
      title1: "Total (Admin)",
      value1: `$${TotalInvestmentAmountAdmin?.toFixed(2)}`,
      title2: "Payable Amount",
      value2: `$${TotalInvestmentPayableAdmin?.toFixed(2)}`,
    },
  ];

  const wallerData = [
    {
      title: "Total Main Balance",
      value: data?.wallets?.mainBalance?.toFixed(2),
      icon: "/icons/users.svg",
    },
    {
      title: "Total Income Balance",
      value: data?.wallets?.incomeBalance?.toFixed(2),
      icon: "/icons/revenue.svg",
    },
  ];
  return (
    <div className="hide">
    <div className={styles.dashBoardContainer}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h3>DASHBOARD</h3>

        <div style={{ display: "flex", gap: "2rem" }}>
          <div className={styles.inputBox}>
            <span>From</span>
            <div className={styles.inputBoxChild}>
              <input
                type="date"
                className={styles.inputField}
                onChange={(e) => {
                  setParameter({ ...parameter, fromDate: e.target.value });
                }}
                value={parameter?.fromDate}
              />
            </div>
          </div>
          <div className={styles.inputBox}>
            <span>To</span>
            <div className={styles.inputBoxChild}>
              <input
                type="date"
                className={styles.inputField}
                onChange={(e) => {
                  setParameter({ ...parameter, toDate: e.target.value });
                }}
                value={parameter?.toDate}
              />
            </div>
          </div>
        </div>
      </div>
      <div style={{ marginTop: "1rem" }}>
        <h4>Reward</h4>
        <Stats statsData={rewardData} />
      </div>
      <div>
        <h4>Transactions</h4>

        <Stats statsData={transactionData} />
      </div>
      <div>
        <h4>Investment</h4>

        <Stats statsData={investmentData} type="investment" />
      </div>

      <div>
        <h4>Wallet Data</h4>
        <Stats statsData={wallerData} />
      </div>
    </div>
    </div>
  );
}
